import { Component, OnDestroy, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { Task } from 'src/app/shared/task';
import { FirebaseService } from 'src/app/shared/firebase.service';
import { Router } from '@angular/router';
import { ControlService } from 'src/app/shared/control.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-game',
  templateUrl: './game.component.html',
  styleUrls: ['./game.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GameComponent implements OnDestroy {
  start = false;
  currentIndex = 0;
  tasks: Task[];
  currentTask: Task;
  taskFinished = false;
  failedCounter = 0;
  playerIndex = 0;
  player: string;
  userId: string;
  rating: 'Like' | 'Dislike';
  currentLanguage: string;
  text: string;

  constructor(
    private fireBaseService: FirebaseService,
    private controlService: ControlService,
    private router: Router
  ) {
    this.currentLanguage = localStorage.getItem('language');
    if (!this.fireBaseService.collection.length) {
      this.router.navigate(['/', 'collections']);
    }
    this.userId = this.genUUID();
    this.tasks = this.fireBaseService.collection.filter((el) => el.isGeneral);
    this.tasks = [...this.tasks.filter(el => !el.wildy).sort(() => Math.random() - 0.5),
      ...this.tasks.filter(el => el.wildy).sort(() => Math.random() - 0.5)];
    this.currentTask = this.tasks[this.currentIndex];
    this.text = this.currentTask[this.currentLanguage];
    this.controlService.failedCounter
      .pipe(untilDestroyed(this))
      .subscribe((res) => (this.failedCounter = res));
    this.player = this.controlService.players[this.playerIndex];
  }

  ngOnDestroy(): void {}

  next(): void {
    this.taskFinished = false;
    this.rating = undefined;
    if (this.currentIndex !== this.tasks.length - 1) {
      this.currentIndex += 1;
      this.currentTask = this.tasks[this.currentIndex];
      this.text = this.currentTask[this.currentLanguage];
      this.setCurrentPlayer();
    } else {
      this.router.navigate(['/', 'game-over']);
    }
  }

  setCurrentPlayer() {
    if (this.controlService.players.length - 1 !== this.playerIndex) {
      this.playerIndex += 1;
    } else {
      this.playerIndex = 0;
    }
    this.player = this.controlService.players[this.playerIndex];
  }

  onFinished(): void {
    this.taskFinished = true;
  }

  like(): void {
    this.rating = 'Like';
    this.fireBaseService.likeTask(this.currentTask.ID, this.userId);
  }

  dislike(): void {
    this.rating = 'Dislike';
    this.fireBaseService.dislikeTask(this.currentTask.ID, this.userId);
  }

  handleDebug(id: number): void {
    const debugTaskIndex = this.tasks.findIndex(task => task.ID === id);
    if (debugTaskIndex !== -1) {
      this.currentIndex = debugTaskIndex;
      this.currentTask = this.tasks[this.currentIndex];
      this.text = this.currentTask[this.currentLanguage];
    } else {
      console.log('%c No task found', 'color: #red; font-size: medium');
    }
  }

  private genUUID() {
    // Reference: https://stackoverflow.com/a/2117523/709884
    return ('10000000-1000-4000-8000-100000000000').replace(/[018]/g, s => {
      const c = Number.parseInt(s, 10);
      // tslint:disable-next-line: no-bitwise
      return (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16);
    });
  }
}
